import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { aboutPageData, seoData } from "@/mocks/manga";

export default function AboutPage() {
  const pageTitle = `关于我们 - 36漫画网 - 海量正版漫画免费在线阅读平台`;
  const pageDesc = `36漫画网是国内领先的在线漫画阅读平台，提供超过10万部正版漫画免费在线阅读。了解我们的品牌故事、发展历程、核心优势及联系方式。`;
  const pageKeywords = `36漫画网,关于我们,漫画平台,正版漫画,免费阅读漫画,在线漫画`;

  const breadcrumbItems = [
    { label: "首页", path: "/" },
    { label: "关于我们" },
  ];

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": seoData.siteName,
    "url": seoData.url,
    "description": seoData.description,
    "email": aboutPageData.contact.email,
    "telephone": aboutPageData.contact.phone,
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "北京",
      "addressRegion": "朝阳区",
      "streetAddress": "望京科技园区36号漫画大厦",
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": aboutPageData.contact.phone,
      "contactType": "customer service",
      "availableLanguage": "Chinese",
    },
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "36漫画网的漫画都是免费的吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "36漫画网提供大量漫画免费在线阅读服务，部分独家内容可能需要会员权益。我们致力于让更多读者享受到优质漫画阅读体验。",
        },
      },
      {
        "@type": "Question",
        "name": "如何在36漫画网找到想看的漫画？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "您可以通过首页的分类导航、搜索功能，或浏览热门推荐、最新上架等栏目来找到心仪的漫画。我们的AI推荐系统也会根据您的阅读偏好为您精准推送。",
        },
      },
      {
        "@type": "Question",
        "name": "36漫画网支持哪些设备阅读？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "36漫画网支持PC端、手机端和平板端无缝阅读，阅读进度实时同步，让您随时随地享受漫画阅读的乐趣。",
        },
      },
      {
        "@type": "Question",
        "name": "3077甜蜜暴击第二季在哪里可以看？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "3077甜蜜暴击第二季全集无删减版可在36漫画网免费在线阅读。您可以在首页直接点击阅读按钮，或通过搜索功能找到该作品。所有章节一网打尽，享受原汁原味的完整故事。",
        },
      },
      {
        "@type": "Question",
        "name": "漫画更新频率是怎样的？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "36漫画网每日更新数百章节，热门连载漫画通常每周更新一至两话，具体更新频率取决于各漫画工作室的排期。您可以在漫画详情页查看最新更新日期。",
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl={`${seoData.url}/about`}
        schemaJson={{ ...orgSchema }}
      />
      <Navbar />

      <main className="pt-16">
        {/* Page Header */}
        <div className="w-full px-4 md:px-6 py-6 bg-background-50 border-b border-background-200/70">
          <div className="max-w-[1280px] mx-auto">
            <Breadcrumb items={breadcrumbItems} />
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
              关于我们
            </h1>
            <p className="text-sm text-foreground-500 mt-2">
              了解36漫画网的故事与使命
            </p>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="w-full px-4 md:px-6 py-14">
          <div className="max-w-[960px] mx-auto">
            <div className="flex flex-col md:flex-row gap-8 items-center">
              <div className="flex-1">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-4">
                  <i className="ri-building-line text-primary-500 mr-2"></i>
                  品牌介绍
                </h2>
                <p className="text-sm leading-relaxed text-foreground-600 mb-4">
                  {aboutPageData.brandIntro}
                </p>
                <p className="text-sm leading-relaxed text-foreground-600">
                  我们的使命是让每一位漫画爱好者都能轻松获取高品质的漫画内容。从经典的恋爱甜宠到热血冒险，从搞笑日常到悬疑奇幻，36漫画网涵盖了最全面的漫画品类，满足不同读者的多样化需求。我们与国内超过50家漫画工作室和出版社建立了深度合作关系，确保内容的丰富性与权威性。
                </p>
              </div>
              <div className="flex-shrink-0 w-full md:w-[360px]">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20creative%20office%20space%20with%20colorful%20manga%20art%20on%20walls%2C%20warm%20lighting%2C%20comfortable%20workspace%2C%20team%20collaboration%20vibe%2C%20creative%20studio%20atmosphere%2C%20clean%20and%20bright%20interior%2C%20artistic%20decor%2C%20photography%20style&width=720&height=540&seq=about-brand-image&orientation=landscape"
                  alt="36漫画网办公环境"
                  className="rounded-xl w-full h-auto"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Development Timeline */}
        <section className="w-full px-4 md:px-6 py-14 bg-background-100">
          <div className="max-w-[960px] mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center">
              <i className="ri-timeline-view text-accent-500 mr-2"></i>
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300 md:left-1/2 md:-translate-x-px"></div>
              <div className="space-y-8">
                {aboutPageData.history.map((item, idx) => (
                  <div key={idx} className={`relative flex items-start gap-6 md:gap-0 ${
                    idx % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                  }`}>
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center z-10 md:mx-auto md:absolute md:left-1/2 md:-translate-x-1/2">
                      <span className="text-xs font-bold">{idx + 1}</span>
                    </div>
                    <div className={`flex-1 ${idx % 2 === 0 ? "md:pr-[60px] md:text-right" : "md:pl-[60px]"}`}>
                      <div className="bg-background-50 rounded-xl p-4 border border-background-200/70 inline-block max-w-full">
                        <span className="text-xs font-bold text-primary-500">{item.year}</span>
                        <p className="text-sm text-foreground-700 mt-1">{item.event}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Core Features */}
        <section className="w-full px-4 md:px-6 py-14">
          <div className="max-w-[960px] mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center">
              <i className="ri-star-line text-accent-500 mr-2"></i>
              为什么选择我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {aboutPageData.features.map((feature, idx) => (
                <div key={idx} className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-colors">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mb-3">
                    <i className={`text-primary-500 text-lg ${
                      idx === 0 ? "ri-book-2-line" :
                      idx === 1 ? "ri-hd-line" :
                      idx === 2 ? "ri-money-cny-circle-line" :
                      idx === 3 ? "ri-brain-line" :
                      idx === 4 ? "ri-device-line" :
                      "ri-chat-smile-2-line"
                    }`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-800 mb-2">{feature.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* User Testimonials */}
        <section className="w-full px-4 md:px-6 py-14 bg-background-100">
          <div className="max-w-[960px] mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center">
              <i className="ri-chat-heart-line text-accent-500 mr-2"></i>
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {aboutPageData.testimonials.map((testimonial, idx) => (
                <div key={idx} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: testimonial.rating }, (_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    "{testimonial.content}"
                  </p>
                  <p className="text-xs font-medium text-foreground-800">
                    — {testimonial.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section className="w-full px-4 md:px-6 py-14">
          <div className="max-w-[960px] mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center">
              <i className="ri-customer-service-line text-primary-500 mr-2"></i>
              联系我们
            </h2>
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-mail-line text-primary-500 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                    <p className="text-sm font-medium text-foreground-800">{aboutPageData.contact.email}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className="ri-phone-line text-accent-500 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">客服电话</p>
                    <p className="text-sm font-medium text-foreground-800">{aboutPageData.contact.phone}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                    <i className="ri-map-pin-line text-secondary-500 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">公司地址</p>
                    <p className="text-sm font-medium text-foreground-800">{aboutPageData.contact.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-wechat-line text-primary-500 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">微信公众号</p>
                    <p className="text-sm font-medium text-foreground-800">{aboutPageData.contact.wechat}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className="ri-weibo-line text-accent-500 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">官方微博</p>
                    <p className="text-sm font-medium text-foreground-800">{aboutPageData.contact.weibo}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                    <i className="ri-time-line text-secondary-500 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500 mb-0.5">工作时间</p>
                    <p className="text-sm font-medium text-foreground-800">周一至周日 9:00 - 21:00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full px-4 md:px-6 py-14 bg-background-100">
          <div className="max-w-[960px] mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center">
              <i className="ri-question-answer-line text-accent-500 mr-2"></i>
              常见问题
            </h2>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
            />
            <div className="space-y-3">
              {faqSchema.mainEntity.map((faq, idx) => (
                <details key={idx} className="bg-background-50 rounded-xl border border-background-200/70 group">
                  <summary className="px-5 py-4 cursor-pointer flex items-center justify-between text-sm font-medium text-foreground-800 hover:text-primary-500 transition-colors">
                    {faq.name}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.acceptedAnswer.text}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}